var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fps-img-wrap"},[_c('div',{staticClass:"fps-img-box"},[_c('img',{ref:"img",staticClass:"fps-img-self",class:{
        'opacity': _vm.loaded ? 1 : 0
      },style:({
        'border-radius': _vm.borderRadius,
      }),attrs:{"data-src":_vm.src,"alt":""},on:{"load":_vm.imgLoaded,"error":_vm.imgErrored}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loaded),expression:"!loaded"}],staticClass:"fps-img-place",style:({
      'border-radius': _vm.borderRadius,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }